import { render, staticRenderFns } from "./IgFinanceInfo.vue?vue&type=template&id=60748bc4&scoped=true&"
import script from "./IgFinanceInfo.vue?vue&type=script&lang=js&"
export * from "./IgFinanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./IgFinanceInfo.vue?vue&type=style&index=0&id=60748bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60748bc4",
  null
  
)

export default component.exports